<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { Label } from '@/components/ui/label';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <Label
    data-slot="field-label"
    :class="
      cn(
        'group/field-label peer/field-label flex w-fit gap-2 text-sm font-medium leading-snug text-text-secondary-600 group-data-[disabled=true]/field:opacity-50',
        'has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col has-[>[data-slot=field]]:rounded-md has-[>[data-slot=field]]:border [&_>[data-slot=field]]:p-3',
        'has-[[data-state=checked]]:bg-primary/5 dark:has-[[data-state=checked]]:bg-primary/10 has-[[data-state=checked]]:border-primary',
        props.class,
      )
    "
  >
    <slot />
  </Label>
</template>
